"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Discussion = require("../Discussion");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var ApplicationReplyBody =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ApplicationReplyBody, _Component);

  function ApplicationReplyBody() {
    babelHelpers.classCallCheck(this, ApplicationReplyBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ApplicationReplyBody).apply(this, arguments));
  }

  babelHelpers.createClass(ApplicationReplyBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment comment-text",
        style: {
          whiteSpace: 'pre-line'
        }
      }, this.props.children);
    }
  }]);
  return ApplicationReplyBody;
}(_react.Component);

var ApplicationReplyNode = (_class = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ApplicationReplyNode, _Component2);

  function ApplicationReplyNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ApplicationReplyNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ApplicationReplyNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentPosted", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackData", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ApplicationReplyNode, [{
    key: "render",
    value: function render() {
      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(_node.default, {
          node: this.node.node,
          discussion: this.discussion,
          className: this.node.node.privateReply ? "private" : "",
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          oldFooter: this.node.node.permissions.delete ? _react.default.createElement("footer", null, _react.default.createElement("div", {
            className: "submit"
          }, _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doDelete,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "delete"
          }), "\xA0 Delete"))) : null
        }, _react.default.createElement(ApplicationReplyBody, null, this.node.node.comment)));
      }

      return null;
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this2 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The comment has been deleted.');

        _this2.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }]);
  return ApplicationReplyNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doDelete"), _class.prototype)), _class);
exports.default = ApplicationReplyNode;